import { Folder, Layer, LayerTypes } from '../../store/cop/models';
import { FolderUtils } from './folder-utils';
import { MapLayerSummary } from '../../store/lsd/models/map-layer-summary.model';
import { Map } from '../../store/cop/models/map.model';
import { FolderConfiguration, FolderWidgetType, ListByWorkflowStepWidgetConfig } from '../../store/lsd/models/map-configuration.model';

export class WorkflowUtils {
  static getWorkflowStatusSummaryModelFromMap(map: Map): MapLayerSummary[] {
    if (!map) {
      return [];
    }

    const folders = map.folders;
    if (map.version !== 1) {
      return [{ type: 'layer-type', layerType: LayerTypes.Alert, summaryByStatus: [], statusCounts: { inProgress: 0, pending: 0 } }];
    }
    return Object.values(
      FolderUtils.reduceMapFolderTree<Folder[]>(
        folders,
        (value: Folder, parent: Folder, state: Folder[]) => {
          // If I'm a section store my UId
          if (value.sectionType > 0) {
            state[value.uId] = value;
          }
        },
        (value: Layer, parent: Folder, state: Folder[]) => {
          // Layer no-op
        },
        []
      )
    )
      .map(folder => {
        const config = folder.configuration ? (JSON.parse(folder.configuration) as FolderConfiguration) : null;
        const listConfig = config?.widgets?.find(w => w.type === FolderWidgetType.ListByWorkflowStep) as ListByWorkflowStepWidgetConfig;
        if (listConfig || config?.viewMode === 'workflow') {
          return {
            type: 'section',
            sectionUId: folder.uId,
            statusCounts: {
              inProgress: 0,
              pending: 0
            },
            stepsInSummary: listConfig?.stepsInSummary,
            summaryByStatus: []
          } as MapLayerSummary;
        }
        return null;
      })
      .filter(s => !!s);
  }
}
